// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"302":"62b981e8","453":"3d0ebd7c","610":"f4231572"}[chunkId] + ".chunk.js";
};